import clock from '../../assets/plus.png';

const Insights = () => {
  return (
    <div className="min-h-[300px] min-w-[300px] border border-gray-300 bg-white rounded-lg overflow-hidden">
      <div className="border-b border-[#2C5282] bg-[linear-gradient(0deg,_rgba(44,82,130,0.80)_0%,_rgba(44,82,130,0.80)_100%)] text-white p-4 flex items-center justify-center gap-2">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <g clip-path="url(#clip0_7253_36335)">
    <path d="M10.75 0.5H5.25V5.25H0.5V10.75H5.25V15.5H10.75V10.75H15.5V5.25H10.75V0.5ZM14.5 6.25V9.75H9.75V14.5H6.25V9.75H1.5V6.25H6.25V1.5H9.75V6.25H14.5Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_7253_36335">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
  </defs>
</svg>
        <span className='text-md font-semibold'>Contextual Insights</span>
      </div>
      <div className="p-4">
        {/* Timeline content goes here */}
       
      </div>
    </div>
  );
};

export default Insights;
